<script setup lang="ts">
import { defineOptions } from "vue";
import { Parameter } from "@/store/search";

defineOptions({ name: "ProjectListItemParameter" });

defineProps<{
	parameter: Parameter
}>();
</script>

<template>
	<div class="parameter">
		<template v-if="parameter.Type === 0 && parameter.Instance">
			<template v-if="!parameter.Instance.IsRecord">
				<span class="parameter__name">{{ parameter.Instance.Key }}:&nbsp;</span>
				<span class="parameter__value" v-html="parameter.Instance.Value"/>
			</template>
			<template v-else>
				<div class="parameter__record-title">Запись "{{ parameter.Instance.Key }}":</div>
				<ProjectListItemParameter
					v-for="(field, idx) in parameter.Instance.RecordFields"
					:key="idx"
					:parameter="field"
					class="parameter__nested"
				/>
			</template>
		</template>

		<template v-else-if="parameter.Type === 1 && parameter.ListTitle">
			<span class="parameter__name">{{ parameter.ListTitle.Name }}:&nbsp;</span>
			<template
				v-for="(inst, idx) in parameter.ListTitle.Instances"
				:key="idx"
			>
				<template v-if="!inst.IsRecord">
					<span class="parameter__value" v-html="inst.Value"/>
					<span
						v-if="idx < parameter.ListTitle.Instances.length - 1 && inst.Value"
						class="parameter__separator"
					>;&nbsp;</span>
				</template>
				<template v-else>
					<div class="parameter__record-title">Запись "{{ inst.Key }}":</div>
					<ProjectListItemParameter
						v-for="(field, fIdx) in inst.RecordFields"
						:key="fIdx"
						:parameter="field"
						class="parameter__nested"
					/>
				</template>
			</template>
		</template>
	</div>
</template>

<style scoped lang="scss">
.parameter {
	display: block;
	color: #4D4D4D;
	font-size: 14px;
	line-height: 18px;

	&__name {
		font-weight: 500;
	}

	&__record-title {
		font-weight: 500;
	}

	&__nested {
		padding-left: 8px;
	}
}
</style>
